import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';

@Component({
    selector: 'lib-rc-item-layout',
    template: `<ng-template #signleItemContent>
  <ng-content></ng-content>
</ng-template>`,
    styles: [``]
})
export class RcItemLayoutComponent implements OnInit {
    @ViewChild('signleItemContent', {read: TemplateRef}) signleItemContent;


    ngOnInit(): void {

    }
}